export default __webpack_public_path__ + "static/media/phil-botha-a0TJ3hy-UD8-unsplash.f68135e6.jpg";